import { useAuthenticatedImage } from "@/hooks/useAuthenticatedImage";
import { useGetEmployeeSettingsQuery } from "@/store/api/employeeApi";
import { useEmployeeAccess } from "../access/useEmployeeAccess";

/**
 * The organisation's logo and name (P3-11), beside the skyEmployee wordmark
 * in the header. Nothing shows until an Admin sets them, or for someone
 * without skyEmployee access. Colours stay Skypoint's.
 */
export function OrgBrand() {
  const access = useEmployeeAccess();
  const { data } = useGetEmployeeSettingsQuery(undefined, { skip: !access.me });
  const branding = data?.branding;
  const logo = useAuthenticatedImage(branding?.logoUrl ?? null);
  if (!branding || (!branding.orgName && !branding.logoUrl)) return null;

  return (
    <span className="ml-3 flex items-center gap-2 border-l border-white/20 pl-3">
      {logo && (
        <img
          src={logo}
          alt={branding.orgName ? "" : "Organisation logo"}
          className="h-6 w-auto max-w-24 object-contain"
        />
      )}
      {branding.orgName && (
        <span className="max-w-48 truncate text-sm font-medium text-white/90">
          {branding.orgName}
        </span>
      )}
    </span>
  );
}
